import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Widget } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import Modal from '@lib/components/Modal/Modal';
import prepareWidgetTemplatePreview from 'routes/Home/utils/prepareWidgetTemplatePreview';
import WidgetContent from '../WidgetContent/WidgetContent';
import WidgetWrap from '../WidgetWrap';

interface WidgetTemplatePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  formValues: Values;
}

export default function WidgetTemplatePreviewModal({
  isOpen,
  onClose,
  formValues,
}: WidgetTemplatePreviewModalProps) {
  const { t } = useTranslation();

  // Convert form values to widget format for preview
  const previewWidget = useMemo(() => {
    if (!isOpen) return null;
    return prepareWidgetTemplatePreview(formValues);
  }, [formValues, isOpen]);

  if (!previewWidget) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      caption={t('preview')}
      destroyOnHidden
    >
      <WidgetWrap>
        <WidgetContent widget={previewWidget as Widget} />
      </WidgetWrap>
    </Modal>
  );
}
